import { useState, React, useEffect } from "react";
import cardBoxImage from "../../assets/images/cardboxbg.png";
import Back from "../../assets/images/backbtn.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { createLivestock, fetchMeatCategory } from "../../services/livestock";
import AddDippingForm from "../../components/dippingAndVaccination/AddDippingForm";
import { createDipping } from "../../services/dipping";
import showNotification from "../../components/notification/notification";
import { Button, Modal } from "react-bootstrap";

const AddDippingAndVaccination = () => {
  const navigate = useNavigate();
  const [menubuttons, setMenubuttons] = useState([]);
  const [selectedMenuButtons, setSelectedMenuButtons] = useState([]);
  const [show, setShow] = useState(false);
  const [opacity, setOpacity] = useState(1);

  const addDippingFormik = useFormik({
    initialValues: {
      vaccinationDetails: [],
    },
    onSubmit: async (values) => {
      if (values.vaccinationDetails.length) {
        const res = await createDipping(values);
        if (res.status) {
          navigate("/");
          showNotification(
            "Dipping, Spraying & vaccination data added successfully!",
            " success"
          );
        }
      } else {
        alert("Please select animal");
      }
    },
  });

  const getMeatCategory = async () => {
    const res = await fetchMeatCategory();
    if (res.status) {
      setMenubuttons(res.data);
    }
  };

  useEffect(() => {
    getMeatCategory();
  }, []);

  const onAnimalSelect = (button) => {
    console.log(button);
    const checkExist = selectedMenuButtons.some((x) => x === button._id);
    if (checkExist) {
      setSelectedMenuButtons(
        selectedMenuButtons.filter((value) => {
          return value !== button._id;
        })
      );
    } else {
      setSelectedMenuButtons([...selectedMenuButtons, button._id]);
    }

    const regionId = JSON.parse(localStorage.getItem("data")).regionDetails[0]
      ._id;

    let checkArrayExist = addDippingFormik.values.vaccinationDetails.some(
      (details) => details.liveStockId === button._id
    );
    if (checkArrayExist) {
      addDippingFormik.setFieldValue(
        "vaccinationDetails",
        addDippingFormik.values.vaccinationDetails.filter((value) => {
          return value.liveStockId !== button._id;
        })
      );
    } else {
      addDippingFormik.setFieldValue("vaccinationDetails", [
        ...addDippingFormik.values.vaccinationDetails,
        {
          regionId: regionId,
          liveStockId: button._id,
          animalTypeName: button.name,
          dippedCount: "",
          medicineApplied: "",
          sprayCount: "",
          vaccinatedCount: "",
          vaccinationCount: "",
        },
      ]);
    }
  };

  const reset = () => {
    let tempArray = [...addDippingFormik.values.vaccinationDetails];
    setSelectedMenuButtons([]);
    tempArray.forEach((element) => {
      element.dippedCount = "";
      element.medicineApplied = "";
      element.sprayCount = "";
      element.vaccinatedCount = "";
      element.vaccinationCount = "";
    });
    addDippingFormik.setFieldValue("vaccinationDetails", []);
  };

  const changeFormValue = (index, value, changeKey) => {
    let tempArray = [...addDippingFormik.values.vaccinationDetails];
    tempArray[index][`${changeKey}`] = value;
    addDippingFormik.setFieldValue("vaccinationDetails", tempArray);
  };
  const goBack = () => {
    navigate(-1);
  };
  const addUserReset = () => {
    reset();
    setShow(false);
    setOpacity(0);
  };
  const handleClose = () => {
    setShow(false);
    setOpacity(0);
  };
  const handleShow = () => {
    setShow(true);
    setOpacity(1);
  };
  return (
    <div className="theme-container">
      <div className="contentCard2">
        <div className="contentCardHeader addProdctHeader">
          <h3>Add Dipping, Spraying & Vaccination</h3>
          <button onClick={goBack}>
            <img
              src={Back}
              alt=""
            />{" "}
            Back
          </button>
        </div>
        <div className="cardbg">
          <img
            src={cardBoxImage}
            alt="card bg"
          />
        </div>
      </div>
      {/* -------------------Form---------------------- */}
      <form onSubmit={addDippingFormik.handleSubmit}>
        <div className="politryStockForm">
          <div className="politryStock">
            <div className="AddprodRow1Egg">
              <div className="eggLogFarmer">
                <div className="farmersBox">
                  Animal Type
                  <div className="buttons">
                    {menubuttons &&
                      menubuttons[0]?.productCategories?.map(
                        (button, index) => {
                          return (
                            <button
                              key={index}
                              type="button"
                              className={`${
                                selectedMenuButtons?.some(
                                  (x) => x === button._id
                                )
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => onAnimalSelect(button)}>
                              {button.name}
                            </button>
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            </div>
            {addDippingFormik?.values?.vaccinationDetails.map(
              (value, index) => {
                return (
                  <AddDippingForm
                    index={index}
                    formData={value}
                    changeFormValue={changeFormValue}
                  />
                );
              }
            )}
          </div>
          {addDippingFormik.values.vaccinationDetails.length ? (
            <div className="bottomButtons">
              <button
                type="submit"
                className="addprdt active"
                id="addprdt">
                Add Dipping, Spraying & Vaccination
              </button>
              <button
                type="reset"
                className="reset"
                id="rst"
                onClick={handleShow}>
                {" "}
                Reset
              </button>
            </div>
          ) : (
            <div className="select-animal-type">
              {" "}
              <p>Please Select Animal </p>
            </div>
          )}
        </div>
      </form>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{ opacity: opacity }}>
        <Modal.Header closeButton>
          <Modal.Title> Reset?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}>
            No
          </Button>
          <Button
            variant="primary"
            onClick={addUserReset}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddDippingAndVaccination;
